export default "__VITE_ASSET__B3luXvMY__"